// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-action-template/src/index.tsx

// TODO: Check if the icon is alined properly.
// If it is not: Replace/extend defaultAlignedActionIconGroupProps to make it look right.
// https://stash.int.klarna.net/projects/UI/repos/bubble-ui/pull-requests/121/overview?commentId=2244923
import { baseActionIcon } from '@bubble-ui/temp-action-icon-base';
import { isWaffle, isWhiteLabel } from '@bubble-ui/particle-design-versions';
var ActionIconCheckmarkPathPancake = 'M10.215 1 4.292 8.558 1.414 5.68 0 7.094l3.676 3.676a.999.999 0 0 0 .707.293l.06-.002c.286-.018.55-.157.727-.381l6.619-8.446L10.215 1Z';
var ActionIconCheckmarkPathWaffle = 'M4.582 10.674a.7.7 0 0 1-.495-.205L.13 6.512l.99-.99 3.297 3.296a35.15 35.15 0 0 1 2.477-3.78A37.617 37.617 0 0 1 10.89.523l.97 1.008a36.268 36.268 0 0 0-3.846 4.347A33.578 33.578 0 0 0 5.2 10.3a.7.7 0 0 1-.618.373Z';
var ActionIconCheckmarkPathWaffleFilled = 'M4.582 10.674a.7.7 0 0 1-.495-.205L.13 6.512l.99-.99 3.297 3.296a35.15 35.15 0 0 1 2.477-3.78A37.617 37.617 0 0 1 10.89.523l.97 1.008a36.268 36.268 0 0 0-3.846 4.347A33.578 33.578 0 0 0 5.2 10.3a.7.7 0 0 1-.618.373Z';
var ActionIconCheckmarkPathWhiteLabel = 'M4.545 9.563.67 6.063 1.72 5l2.825 2.463L10.22 2l1.05 1.05-6.725 6.513Z';
var ActionIconCheckmarkPathWhiteLabelFilled = 'M4.545 9.563.67 6.063 1.72 5l2.825 2.463L10.22 2l1.05 1.05-6.725 6.513Z';
export var ActionIconCheckmark = baseActionIcon('ActionIconCheckmark', {
  getPath: _ref => {
    var {
      designVersion,
      filled
    } = _ref;
    return isWhiteLabel(designVersion) ? filled ? ActionIconCheckmarkPathWhiteLabelFilled : ActionIconCheckmarkPathWhiteLabel : isWaffle(designVersion) ? filled ? ActionIconCheckmarkPathWaffleFilled : ActionIconCheckmarkPathWaffle : ActionIconCheckmarkPathPancake;
  }
});
//# sourceMappingURL=index.js.map